module.exports = __webpack_public_path__ + "039f32e782cc04ee3de8825bc3b6ed9c.jpg";